import { drugsDataListSelector } from '@/redux/drugs/drugs.selectors';
import { store } from '@/redux/store';
import type { Drug } from 'minerva-plugin-api';
import { toPluginDrug } from '@/services/pluginsManager/adapters/toPluginModelElement';

export const getAllDrugs = (): Drug[] => {
  const { getState } = store;
  const drugs = drugsDataListSelector(getState());

  return (drugs || []).map(toPluginDrug);
};
